import { useEffect } from 'react';
import { notifications } from '@mantine/notifications';
import { useIntl } from 'react-intl';
import {
  getAppVersion,
  getPreviousVersion,
  clearPreviousVersion,
} from '@/commons/versionManager';

/**
 * Component that shows a notification when the app version changes
 * Should be included once in the app root
 */
export const VersionChangeNotifier = () => {
  const intl = useIntl();

  useEffect(() => {
    const previousVersion = getPreviousVersion();
    const currentVersion = getAppVersion();

    if (previousVersion && previousVersion !== currentVersion) {
      notifications.show({
        color: 'blue',
        title: intl.formatMessage({ id: 'appUpdated' }),
        message: intl.formatMessage(
          { id: 'appVersionChanged' },
          {
            oldVersion: previousVersion,
            newVersion: currentVersion,
          }
        ),
        autoClose: 5000,
      });

      // Clear the previous version so notification doesn't show again
      clearPreviousVersion();
    }
  }, [intl]);

  return null;
};
